import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// Components
import { SkyscraperAd } from '../../components/global/Ads/SkyscraperAd';

// Helpers
import { getAdData } from '../../utils/adHelpers';

const SbSharedSkyscraperAdComponent = ({ searchBrowse }) => {
    const { displayUriRef } = searchBrowse;
    const skyscraperAdData = getAdData(displayUriRef, 'skyscraper');

    if (!skyscraperAdData) {
        return null;
    }

    return <SkyscraperAd {...skyscraperAdData} />;
};

SbSharedSkyscraperAdComponent.propTypes = {
    searchBrowse: PropTypes.object.isRequired,
};

export const SbSharedSkyscraperAd = createFragmentContainer(SbSharedSkyscraperAdComponent, {
    searchBrowse: graphql`
        fragment SbSharedSkyscraperAd_searchBrowse on SearchBrowseQueryConnection {
            displayUriRef
        }
    `,
});
